const register = {
  loginCredentials: "로그인 자격 증명", // translated 
  companyInformation: "회사 정보", // translated 
  contactDetails: "연락처 정보", // translated 
  businessName: "회사명", // translated 
  businessAddress: "사업장 주소", // translated 
  registrationCode: "등록 코드", // translated 
  businessRegistrationNumber: "사업자 등록 번호", // translated 
  websiteUrl: "웹사이트 URL", // translated 
  mobilePhone: "휴대폰", // translated 
  regionStateProvince: "지역/주/도", // translated 
  legalTitle: "법적 소유권", // translated 
  city: "도시", // translated 
  postalCode: "우편번호", // translated 
  registrationSuccess: "등록이 완료되었습니다.", // translated 
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "잠시만 기다려 주시면 홈페이지로 이동합니다.", // translated 
  usernameEmail: "사용자 이름 (이메일)", // translated 
  password: "비밀번호", // translated 
  verifyPassword: "비밀번호 확인", // translated 
  documents: "서류", // translated 
  termsAndConditionsSection: "이용약관", // translated 
  certificateOfIncorporation: "법인 설립 증명서", // translated 
  acceptTermsAndConditions: "이용약관에 동의합니다", // translated 
  country: "국가", // translated 
  brandName: "브랜드 이름", // translated 
  register: "등록하다", // translated 
  isRequired: "필수입니다", // translated 
  passwordMin8Chars: "최소 8자 이상이어야 합니다.", // translated 
  passwordRequiresDigit: "최소 1자리 숫자를 포함해야 합니다.", // translated 
  passwordRequiresLowercase: "최소 1개의 소문자를 포함해야 합니다.", // translated 
  passwordRequiresUppercase: "대문자를 최소 1개 이상 포함해야 합니다.", // translated 
  passwordRequiresSpecialChar: '최소 1개의 특수 문자(!@#$%^&*(), .?":{}|<>)를 포함해야 합니다.', // translated 
  uploadFile: "파일 업로드", // translated 
  filename: "파일 이름:", // translated 
  fileType: "유형:", // translated 
  fileSize: "크기:", // translated 
  maxFileSize10Mb: "최대 용량: 10MB", // translated 
  supportedFileTypes: "지원되는 파일 형식:", // translated 
  showPassword: "비밀번호 표시", // translated 
  hidePassword: "비밀번호 숨기기", // translated 
  notAvailable: "해당 없음", // translated 
  fileSizeInKb: "{{size}} KB", // translated 
  mobilePhonePlaceholder: "예: +12025550123", // translated 
  websiteUrlPlaceholder: "http://www.example.com", // translated 
  loading: "로딩 중...", // translated 
  uploadingDocument: "문서 업로드 중...", // translated 
  percentUploaded: "{{percent}}% 업로드됨", // translated 
  registrationSuccessful: "등록이 완료되었습니다.", // translated 
  failedToUploadDocument: "문서 업로드에 실패했습니다.", // translated 
  fieldIsRequired: "{{field}} {{isRequired}}", // translated 
  fieldMinLength: "{{field}}는 {{min}}자보다 길어야 합니다.", // translated 
  fieldMustBeValidEmail: "{{field}}는 유효한 이메일 주소여야 합니다.", // translated 
  fieldPasswordMinLength: "{{field}}는 최소 8자 이상이어야 합니다.", // translated 
  fieldPasswordRequiresDigit: "{{field}}에는 최소 1개의 숫자가 포함되어야 합니다.", // translated 
  fieldPasswordRequiresLowercase: "{{field}}에는 최소 1개의 소문자가 포함되어야 합니다.", // translated 
  fieldPasswordRequiresUppercase: "{{field}}에는 최소 1개의 대문자가 포함되어야 합니다.", // translated 
  fieldPasswordRequiresSpecialChar:
    '{{field}}에는 특수 문자(!@#$%^&*(), .?":{}|<>)가 하나 이상 포함되어야 합니다.', // translated 
  passwordsDoNotMatch: "{{field}}가 {{otherField}}와 일치하지 않습니다.", // translated 
  fieldBetweenLength: "{{field}}는 {{min}}과 {{max}} 문자 사이여야 합니다.", // translated 
  postalCodeBetweenLength: "{{field}} 코드는 {{min}}자와 {{max}}자 사이여야 합니다.", // translated 
  invalidUrlFormat: "잘못된 URL 형식입니다", // translated 
  invalidEmailFormat: "잘못된 이메일 형식입니다", // translated 
  emailMustMatchUsername: "이메일 주소는 사용자 이름(이메일)과 동일해야 합니다.", // translated 
  mobilePhoneIsRequired: "휴대폰이 필요합니다.", // translated 
  certificateFileTooLarge: "인증서 파일 크기가 너무 큽니다.", // translated 
  termsMustBeAccepted: "이용 약관에 동의하셔야 합니다.", // translated 
};


export default register;
